// extracted by mini-css-extract-plugin
export default {"info":"style_info__KJxls","title":"style_title__zewva","text":"style_text__QrpqX","qIcon":"style_qIcon__EQjy1","pIcon":"style_pIcon__zlD-Z"};